import { B as n, b as i } from "./style-8UHgYe1v.js";
import { i as m } from "./isClient-bZWD-rdJ.js";
import { g as f } from "./_commonjsHelpers-OnjxAlhP.js";
const b = (t) => m ? Object.keys(t || n).reduce(
  (r, a) => {
    var c;
    const o = (c = f().window) == null ? void 0 : c.matchMedia(`(min-width:${i[a]}px)`);
    return o != null && o.matches ? a : r;
  },
  null
) || n.xs : n.xs, d = (t) => {
  if (t) {
    if (typeof t == "object") {
      const r = b(t);
      return t == null ? void 0 : t[r];
    }
    return t;
  }
};
export {
  b as a,
  d as g
};
